import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb91c8b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-info" }
const _hoisted_2 = { class: "device-list ws_mt16" }
const _hoisted_3 = { class: "ws_common_operation" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "header" }
const _hoisted_6 = { class: "dialog-footer" }

import { onMounted, ref } from 'vue'
import { devicePage, deviceDelete, deviceOnlinecheck } from '@/api'
import {
  PAGE_SIZES,
  CONNECT_TYPE,
  CODE_ENUM,
  DEVICE_STATUS_ENUM,
} from '@/common'
import { get } from 'lodash'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useProductStore } from '@/stores/product'
import { useDeviceStore } from '@/stores/device'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import { useRouter } from 'vue-router'
import i18n from '@/i18n'
import OperationButtonList from '@/components/operation-button-list'
import moment from 'moment'
import DeviceDistribution from './comonents/device-distribution.vue'
import OrgSelect from '@/components/org-select'
import { useAuthStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const authStore = useAuthStore()

const t = i18n.global.t

const router = useRouter()

const advancedRef = ref()

const buttonList = ref([
  {
    type: 'edit',
    text: t('D_INFO.btnEdit'),
  },
  {
    type: 'delete',
    text: t('D_INFO.btnDelete'),
  },
  {
    type: 'detail',
    text: t('D_INFO.btnDetail'),
  },
])

const deviceStatusOps = [
  {
    label: t('D_INFO.labelNoactive'),
    value: DEVICE_STATUS_ENUM.NOACTIVATE,
  },
  // {
  //   label: t('D_INFO.labelActive'),
  //   value: DEVICE_STATUS_ENUM.INACTIVATE,
  // },
  {
    label: t('D_INFO.labelOffline'),
    value: DEVICE_STATUS_ENUM.OFFLINE,
  },
  {
    label: t('D_INFO.labelOnline'),
    value: DEVICE_STATUS_ENUM.ONLINE,
  },
]

const connectTypeOps = [
  {
    label: '4G',
    value: CONNECT_TYPE['4G'],
  },
  {
    label: 'LEO',
    value: CONNECT_TYPE.LEO,
  },
  {
    label: 'GEO',
    value: CONNECT_TYPE.GEO,
  },
  {
    label: 'Lora',
    value: CONNECT_TYPE.LORA,
  },
]

const deviceStatusMap = {
  [DEVICE_STATUS_ENUM.ONLINE]: 'success',
  [DEVICE_STATUS_ENUM.INACTIVATE]: '',
  [DEVICE_STATUS_ENUM.OFFLINE]: 'info',
  [DEVICE_STATUS_ENUM.NOACTIVATE]: 'warning',
}
const getDeviceTagType = (status: any) => {
  return deviceStatusMap[status]
}

const productStore = useProductStore()
productStore.queryGetewayType()

const deviceStore = useDeviceStore()
deviceStore.queryDeviceOps()

const rowClassName = ({ row }: any) => {
  return row.subDeviceFlag ? '' : 'hiden-expand'
}

const columns = [
  {
    prop: 'deviceName',
    label: t('D_INFO.colName'),
  },
  {
    prop: 'deviceSn',
    label: t('D_INFO.colSn'),
  },
  {
    prop: 'orgName',
    label: '所属组织',
  },
  {
    prop: 'productTypeValue',
    label: t('D_INFO.colProduct'),
  },
  // {
  //   prop: 'connectType',
  //   label: '接入方式',
  // },
]

const subCol = ref([
  {
    prop: 'deviceName',
    label: '子设备名称',
  },
  {
    prop: 'producer',
    label: '厂家',
  },
  {
    prop: '',
    label: '品牌/型号',
    formatter: ({ brand, productModel }: any) => {
      return [brand, productModel].filter(Boolean).join('/')
    },
  },
  {
    prop: 'deviceSn',
    label: '端口号/SN',
  },
  {
    prop: 'variable',
    label: '变量',
  },
])

const onOrgChange = () => {
  formInline.value.deviceId = ''
  deviceStore.queryDeviceOps({
    orgId: formInline.value.orgId,
  })
}

const tableData: any = ref([])
const formInline = ref({
  orgId: '',
  deviceId: '',
  deviceSn: '',
  productKey: '',
  deviceStatusCode: '',
  connectTypes: [],
})

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const tableLoading = ref(false)

const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData()
  const { data, reset } = queryData || {}

  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true

  const res: any = await devicePage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === 0) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}
onMounted(() => {
  fetchList()
})

const toDetail = ({ deviceId }: any) => {
  router.push({
    name: 'device-data',
    query: {
      deviceId,
    },
  })
}

const toEdit = ({ id }: any) => {
  router.push({
    name: 'device-edit',
    query: {
      deviceBindId: id,
    },
  })
}

const removeConf = ref({
  visible: false,
  deviceBindId: '',
})
const removeLoading = ref(false)
const toShowRemoveTips = ({ id }: any) => {
  removeConf.value = {
    visible: true,
    deviceBindId: id,
  }
}
const cancelRemove = () => {
  removeConf.value = {
    visible: false,
    deviceBindId: '',
  }
}
const toDeleteDevice = async () => {
  removeLoading.value = true
  const res: any = await deviceDelete({
    deviceBindIds: [removeConf.value.deviceBindId],
  }).finally(() => {
    removeLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage({
      message: t('D_INFO.delSuccessMsg'),
      type: 'success',
    })
    onSuccess()
    cancelRemove()
  } else {
    ElMessage({
      message: res?.msg || t('D_INFO.delErrorMsg'),
      type: 'error',
    })
  }
}

const onSuccess = () => {
  fetchList()
  deviceStore.queryDeviceOps()
}

const deviceChange = (value: string) => {
  const ops = deviceStore.deviceOps.filter((item: any) => {
    return item.value === value
  })
  formInline.value.deviceSn = (ops.length && ops[0].deviceSn) || ''
}

const deviceCheck = async (deviceId: string) => {
  const res: any = await deviceOnlinecheck({
    deviceId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessageBox.alert(t('D_INFO.commondTip'), t('D_INFO.commondTitle'), {
      autofocus: false,
      confirmButtonText: t('D_INFO.btnYes'),
      callback: () => {},
    })
  }
}

const multipleSelection: any = ref([])
const handleSelectionChange = (val: any) => {
  multipleSelection.value = val
}

const transferConf = ref({
  visible: false,
})
const toDeviceDistributio = () => {
  transferConf.value = {
    visible: true,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AdvancedQueryLayout), {
      ref_key: "advancedRef",
      ref: advancedRef,
      model: formInline.value,
      onFetchList: fetchList,
      "label-width": 92
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "组织名称",
          prop: "orgId"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(OrgSelect), {
              style: {"width":"100%"},
              class: "ws_select",
              modelValue: formInline.value.orgId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.orgId) = $event)),
              onChange: onOrgChange,
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('D_INFO.deviceName'),
          prop: "deviceId"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.deviceId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.deviceId) = $event)),
              filterable: "",
              placeholder: _ctx.$t('D_INFO.deviceNamePla'),
              class: "ws_select",
              onChange: deviceChange,
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deviceStore).deviceOps, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('D_INFO.deviceSn'),
          prop: "deviceSn"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formInline.value.deviceSn,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInline.value.deviceSn) = $event)),
              clearable: "",
              maxlength: "50",
              class: "ws_select"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('D_INFO.productType'),
          prop: "productKey"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.productKey,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formInline.value.productKey) = $event)),
              clearable: "",
              class: "ws_select"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStore).productGetewayType, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.code,
                    label: item.name,
                    value: item.code
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('D_INFO.accessMethod'),
          prop: "connectTypes"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.connectTypes,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formInline.value.connectTypes) = $event)),
              clearable: "",
              class: "ws_select",
              multiple: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(connectTypeOps, (item) => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('D_INFO.deviceStatusCode'),
          prop: "deviceStatusCode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.deviceStatusCode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formInline.value.deviceStatusCode) = $event)),
              filterable: "",
              placeholder: _ctx.$t('D_INFO.deviceStatusCodePla'),
              class: "ws_select",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(deviceStatusOps, (item) => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(authStore).isSuperAdmin)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: toDeviceDistributio,
              disabled: !multipleSelection.value.length,
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("设备分配")
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        stripe: "",
        class: "ws_mt20 device-table",
        "tree-props": { hasChildren: 'subDeviceFlag' },
        "row-class-name": rowClassName,
        onSelectionChange: handleSelectionChange
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, {
            description: _ctx.$t('D_INFO.noData')
          }, null, 8, ["description"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
            return _createVNode(_component_el_table_column, _mergeProps({
              key: item.prop
            }, {
            ...item,
          }, { "show-overflow-tooltip": "" }), null, 16)
          }), 64)),
          _createVNode(_component_el_table_column, {
            "show-overflow-tooltip": "",
            prop: "deviceAddress",
            label: _ctx.$t('D_INFO.colAddress')
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(get)(scope.row, 'deviceLocationInfo.deviceAddress', '-')), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            "show-overflow-tooltip": "",
            prop: "connectType",
            label: _ctx.$t('D_INFO.accessMethod')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            width: "140",
            prop: "deviceStatusName",
            label: _ctx.$t('D_INFO.deviceStatusName')
          }, {
            default: _withCtx((scope) => [
              (scope.row.deviceStatusCode)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    class: "ml-2",
                    type: getDeviceTagType(scope.row.deviceStatusCode)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.deviceStatusName), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"]))
                : _createCommentVNode("", true),
              (
              scope.row.deviceStatusCode === _unref(DEVICE_STATUS_ENUM).OFFLINE &&
              scope.row.supportOnlineMethod
            )
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    onClick: ($event: any) => (deviceCheck(scope.row.deviceId)),
                    class: "ws_ml15 online-check"
                  }, _toDisplayString(_ctx.$t('D_INFO.onlineCheck')), 9, _hoisted_4))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "createDate",
            label: _ctx.$t('D_INFO.colCreateTime'),
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(moment)(scope.row.createDate).format('YYYY-MM-DD HH:mm:ss')), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operation",
            label: _ctx.$t('D_INFO.colOperation'),
            width: "280"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_unref(OperationButtonList), {
                buttonList: buttonList.value,
                scope: scope.row,
                onOnEdit: toEdit,
                onOnDelete: toShowRemoveTips,
                onOnDetail: toDetail
              }, null, 8, ["buttonList", "scope"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: removeConf.value.visible,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((removeConf.value.visible) = $event)),
      width: "500px",
      class: "ws_remove_dialog"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_icon, {
            color: "#F56C6C",
            size: "26",
            class: "ws_mr10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_WarningFilled)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('D_INFO.deviceDeleteTitle')), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_el_button, {
            plain: "",
            onClick: cancelRemove
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('D_INFO.btnCancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            loading: removeLoading.value,
            type: "primary",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (toDeleteDevice()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('D_INFO.btnDelete')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('D_INFO.deviceDeleteTip')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(DeviceDistribution, {
      visible: transferConf.value.visible,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((transferConf.value.visible) = $event)),
      data: multipleSelection.value,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ]))
}
}

})